import { render, staticRenderFns } from "./HoldEmployees.vue?vue&type=template&id=b91359f6&scoped=true"
import script from "./HoldEmployees.vue?vue&type=script&lang=js"
export * from "./HoldEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91359f6",
  null
  
)

export default component.exports